import React from "react";
import {
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
} from "@mui/material";
import { isError, getErrorMsg } from "../../../helper/FormHelper.jsx";

export default function CommonOptionSelection({ item, formik }) {
    const formControlProps = item.props;
    const gridStyle = "size" in item ? item.size : { xs: 12 };
    return (
        <Grid item {...gridStyle}>
            <FormControl fullWidth error={isError(formik, formControlProps.id)}>
                <InputLabel>{formControlProps.label}</InputLabel>
                <Select
                    {...formControlProps}
                    fullWidth
                    value={formik.values[formControlProps.id]}
                    onChange={(event) => {
                        formik.setFieldValue(formControlProps.id, event.target.value);
                    }}
                    onBlur={() => {
                        formik.touched[formControlProps.id] = true;
                    }}
                >
                    <MenuItem value={""} disabled sx={{ ml: 2 }}>
                        {item.placeHolder}
                    </MenuItem>
                    {item.options.map((_opt, i) => (
                        <MenuItem key={`opt-${i}`} value={_opt.value}>
                            {_opt.label}
                        </MenuItem>
                    ))}
                </Select>
                <FormHelperText>{getErrorMsg(formik, formControlProps.id)}</FormHelperText>
            </FormControl>
        </Grid>
    );
}
